/**
 * Signing out (f17.3).
 *
 *   1. `POST /api/auth/logout`, best-effort: it clears the session cookie and
 *      makes sign-out a server-observed, audited moment. A backend problem
 *      must never trap a user in a signed-in state, so a failure is ignored.
 *   2. Clear the query cache, so the next person on this browser cannot see
 *      the previous one's data.
 *   3. Go to the sign-in screen in its "signed out" state, which does NOT
 *      redirect to Microsoft -- otherwise signing out would sign straight back
 *      in. There is no Microsoft sign-out (D5).
 */

import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { api } from '@/api/client';

import { SIGN_IN_PATH } from './signIn';

export function useSignOut(): () => Promise<void> {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    try {
      await api.signOut();
    } catch {
      // Deliberately swallowed. See step 1 above.
    }
    queryClient.clear();
    window.location.assign(`${SIGN_IN_PATH}?signed_out=1`);
  }, [queryClient]);
}
